/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ImageUrl } from '../../utils/constants';
import { getInitials } from '../../utils/methods';
import { AdminCloseIcon, DropIcon, BrandingEmoji } from '../../utils/icons';
import SocialFeedsEmojiPicker from '../SocialFeedsEmojiPicker';
import { updateSocialFeedPost, updateDetailPost } from '../../redux/actions/socialActions';
import { UserInitialsMain } from './styles';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { StyledModal, StyledBody, TopSectionV2, PostButton, PostButtonFeed, PostPopupTop } from '../PhotoAndPostFlow/styles';
import PrivacyPopup from './PrivacyPopup/privacypopup';
import DeletePostPopup from '../DeletePostPopup/deletePostConfirmation';

const CHAR_LIMIT = 3000;

class EditPostPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      caption: this.decodeHTMLEntities(props.feed?.text || ''),
      displayEmojiPicker: false,
      position: { start: 0, end: 0 },
      saving: false,
      showPrivacyPopup: false,
      showDeleteConfirm: false,
      privacyOption: props.feed?.visibility === 'my-community' ? 2 : 1,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.feed?.id !== this.props.feed?.id) {
      this.setState({
        caption: this.decodeHTMLEntities(this.props.feed?.text || ''),
        privacyOption: this.props.feed?.visibility === 'my-community' ? 2 : 1,
      });
    }
  }

  containsDefaultPng = (str) => str?.includes('default.png');

  onCaptionChange = (e) => {
    const value = e.target.value;
    if (value.length > CHAR_LIMIT) return;
    this.setState({
      caption: value,
      position: { start: e.target.selectionStart, end: e.target.selectionEnd },
    });
  };

  addEmoji = (e) => {
    const { caption, position } = this.state;
    const newText = caption.slice(0, position.start) + e.native + caption.slice(position.end);
    if (newText.length > CHAR_LIMIT) return;
    this.setState({
      caption: newText,
      position: { start: position.start + e.native.length, end: position.start + e.native.length },
      displayEmojiPicker: false,
    });
  };
  // Add this helper method to the class
  decodeHTMLEntities = (text) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = text;
    return txt.value;
  };

  togglePrivacyPopup = () => {
    this.setState((prev) => ({ showPrivacyPopup: !prev.showPrivacyPopup }));
  };

  manageCheckBox = (value) => {
    this.setState({ privacyOption: value });
  };

  handleButtonClick = () => {
    const { feed } = this.props;
    const { caption } = this.state;
    const hasOtherContent =
      feed?.post_images?.length > 0 ||
      feed?.moment_images?.length > 0 ||
      feed?.type_id === 7 ||
      (feed?.type_id && feed.type_id !== 1 && feed.type_id !== 2);

    if (!hasOtherContent && !caption.trim()) {
      this.setState({ showDeleteConfirm: true });
    } else {
      this.handleSave();
    }
  };



  handleSave = async () => {
    const { feed, onClose } = this.props;
    const { caption } = this.state;

    const hasOtherContent =
      feed?.post_images?.length > 0 ||
      feed?.moment_images?.length > 0 ||
      feed?.type_id === 7 ||
      (feed?.type_id && feed.type_id !== 1 && feed.type_id !== 2);

    this.setState({ saving: true });
    try {
      const AuthToken = localStorage.getItem('AUTH_TOKEN');
      const res = await fetchApi(`/v1/editSocialPost/${feed.id}`, 'PUT', { text: hasOtherContent ? caption : caption.trim() }, AuthToken);

      const isSuccess =
        res?.status !== 'failed' ||
        res?.data?.message?.toLowerCase().includes('successfully') ||
        res?.message?.toLowerCase().includes('successfully');

      if (isSuccess) {
        toast.success(res?.data?.message || res?.message || 'Post updated');
        const payload = { post_id: feed.id, updatedData: { ...feed, text: hasOtherContent ? caption : caption.trim() } };
        this.props.updateSocialFeedPost(payload);
        this.props.updateDetailPost({ ...feed, text: hasOtherContent ? caption : caption.trim() });
        onClose();
      } else {
        toast.error(res?.data?.message || res?.message || 'Failed to update post');
      }
    } catch {
      toast.error('Failed to update post');
    }
    this.setState({ saving: false });
  };


  render() {
    const { showModal, onClose, feed, updationList } = this.props;
    const { caption, displayEmojiPicker, saving, showPrivacyPopup, showDeleteConfirm, privacyOption } = this.state;
    //const hasImages = feed?.post_images?.length > 0 || feed?.moment_images?.length > 0;
    const hasOtherContent =
    feed?.post_images?.length > 0 ||
    feed?.moment_images?.length > 0 ||
    feed?.type_id === 7 ||
    (feed?.type_id && feed.type_id !== 1 && feed.type_id !== 2);

    const isDeleteMode = !hasOtherContent && !caption.trim();
    const visibilityLabel = privacyOption === 2 ? 'My Community' : 'Public';
    const isNearLimit = caption.length >= CHAR_LIMIT * 0.9;

    return (
      <div>

        {/* ── Edit Post Modal ── */}
        <StyledModal show={showModal} onHide={onClose} width="800px">

          <PostPopupTop>
            <div className='heading'>Edit Post</div>
            <div className='closeIcon' onClick={onClose}>{AdminCloseIcon()}</div>
          </PostPopupTop>

          <div style={{ height: '1px', width: '100%', background: '#EFEFEF', margin: '0' }} />

          <StyledBody>
            <TopSectionV2 maxHeight="320px" margin="16px 0">

              {/* User info + privacy */}
              <div className='user-details'>
                <div className='profile' style={{ width: '60px', height: '60px', borderRadius: '50%', overflow: 'hidden' }}>
                  {feed?.post_owner?.profile_image && !this.containsDefaultPng(feed?.post_owner?.profile_image)
                    ? <img src={`${ImageUrl}/${feed?.post_owner?.profile_image}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    : <UserInitialsMain font>{getInitials(feed?.post_owner?.post_owner_name)}</UserInitialsMain>
                  }
                </div>
                <div className='name-privacy'>
                  <div className='name'>{feed?.post_owner?.post_owner_name}</div>
                  <div className='privacy' onClick={this.togglePrivacyPopup}>
                    {visibilityLabel}
                    <div className='arrow'>{DropIcon('#F37A65')}</div>
                  </div>
                </div>
              </div>

              {/* Caption textarea */}
              <textarea
                value={caption}
                onChange={this.onCaptionChange}
                placeholder="What's on your mind?"
                style={{
                  border: 'none',
                  width: '100%',
                  fontFamily: 'Lato',
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  color: '#184A61',
                  resize: 'none',
                  margin: '16px 0 4px 0',
                  minHeight: '80px',
                  outline: 'none',
                  background: 'transparent',
                }}
              />

              {/* Emoji + char count row */}
              <PostButton>
                <div
                  className='emojiIcon'
                  onClick={() => this.setState((prev) => ({ displayEmojiPicker: !prev.displayEmojiPicker }))}
                >
                  {BrandingEmoji()}
                </div>
                <div className='char-count' style={{ color: isNearLimit ? '#C13D4D' : '#BDBDBD' }}>
                  {caption.length}/{CHAR_LIMIT}
                </div>
              </PostButton>

              {displayEmojiPicker && (
                <SocialFeedsEmojiPicker
                  comment
                  selectEmoji={this.addEmoji}
                  hidePicker={() => this.setState({ displayEmojiPicker: false })}
                />
              )}

              <div style={{ height: '1px', width: '100%', background: '#EFEFEF', margin: '0 0 16px 0' }} />

              {/* Save / Delete button */}
              <PostButtonFeed disable={saving ? 1 : 0}>
                <div
                  className='button'
                  onClick={saving ? null : this.handleButtonClick}
                  style={{
                    background: saving ? '#EFEFEF' : '#DA6C74',
                    color: saving ? '#989898' : '#FEFEFE',
                    cursor: saving ? 'not-allowed' : 'pointer',
                    opacity: (!hasOtherContent && !caption.trim() && !isDeleteMode) ? 0.5 : 1,
                  }}
                >
                  {saving ? 'Saving...' : isDeleteMode ? 'Delete Post' : 'Save Post'}
                </div>
              </PostButtonFeed>


            </TopSectionV2>
          </StyledBody>

        </StyledModal>

        {/* ── Delete Confirmation Popup ── */}
        {showDeleteConfirm && (
          <DeletePostPopup
            showModal={showDeleteConfirm}
            onClose={() => this.setState({ showDeleteConfirm: false })}
            feed={feed}
            updationList={updationList || 'response'}
            onCloseCommentPopup={onClose}
          />
        )}

        {/* ── Privacy Popup ── */}
        {showPrivacyPopup && (
          <PrivacyPopup
            showModal={showPrivacyPopup}
            onClose={this.togglePrivacyPopup}
            manageCheckBox={this.manageCheckBox}
            selectedOption={privacyOption}
          />
        )}

      </div>
    );
  }
}

EditPostPopup.propTypes = {
  showModal: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  feed: PropTypes.object,
  updationList: PropTypes.string,
  updateSocialFeedPost: PropTypes.func,
  updateDetailPost: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  updateSocialFeedPost: (payload) => dispatch(updateSocialFeedPost(payload)),
  updateDetailPost: (data) => dispatch(updateDetailPost(data)),
});

export default connect(null, mapDispatchToProps)(EditPostPopup);
